import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

const useValidationSchema = () => {
  const { t } = useTranslation();

  return yup.object().shape({
    password: yup
      .string()
      .required(
        t('messages:validation.required', { field: t('fields:password') })
      )
      .min(
        8,
        t('messages:validation.minLength', {
          field: t('fields:password'),
          length: '8',
        })
      ),
    confirmPassword: yup
      .string()
      .oneOf(
        [yup.ref('password'), null],
        t('messages:validation.matchingPasswords')
      ),
  });
};

export default useValidationSchema;
